import { CoursesPage } from './CoursesPage';

export default CoursesPage;
